import React from "react";
import { SecureRoute } from "@okta/okta-react";
import { Redirect } from "react-router-dom";
import { useFeatureFlag } from "../../hooks/useFeatureFlag";

export default function FeatureFlagRoute({ flagKey, ...props }) {
  const enabled = useFeatureFlag(flagKey);
  if (!enabled) return <Redirect to="/" />;
  return <SecureRoute {...props} />;
}
